/**
 * @file   ua.js 根据UA判断一些信息
 * @author rongtan<rongtan@baidu.com>
 * @date   2020-11-04
 */

export const UA = typeof window === 'object'
    && window.self === window ? navigator.userAgent : '';

/**
 * 是否是微信
 * @function isWechat
 * @param {string} ua - ua 默认是 userAgent
 * @return { boolean} 判断结果
 */
export function isWechat(ua = UA) {
    return /micromessenger\//i.test(ua);
}

/**
 * 是否是QQ
 * @function isQQ
 * @param {string} ua - ua 默认是 userAgent
 * @return { boolean} 判断结果
 */
export function isQQ(ua = UA) {
    let lowerCaseUa = ua.toLowerCase();
    let isIosQQ = lowerCaseUa.indexOf(' qq') > -1 && lowerCaseUa.indexOf('mqqbrowser');
    let isAndroidQQ = /MQQBrowser/i.test(ua) && /QQ/i.test((ua).split('MQQBrowser'));
    if (isIosQQ || isAndroidQQ) {
        return true;
    }

    return false;

}
